import script from "./BackToTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackToTop.vue?vue&type=script&setup=true&lang=ts"

import "./BackToTop.vue?vue&type=style&index=0&id=c9b40234&lang=scss"

const __exports__ = script;

export default __exports__